type Author = {
  id: number;
  verified: boolean;
  username?: string;
};

// Receipt feedback data type (used by Receipt components)
export type Feedback = {
  feedbackId: string;
  buyerId: number;
  sellerId: number;
  productId: number;
  transactionId: number;
  rating: number;
  text?: string;
  dateCreated: string;
  unread: boolean;
  deleted: boolean;
};

// Feedback list item type (used by Feedback list components)
export type FeedbackItem = {
  author: Author;
  date: string;
  product: {
    id: number;
    preview: {
      [key: number]: string;
    };
  };
  rating: number;
  text: string;
  transaction_id: number;
};

export enum FeedbackRole {
  Seller = 'seller',
  Buyer = 'buyer',
}
